export default "__VITE_ASSET__PoMNWBa4__"